import { useMemo } from 'react'
import { RolodexHistogramFilter, RolodexHistogramFilterOp } from 'types'

export function useDefaultFilters(
  orgId: string | null,
  siteId: string | null
): ReadonlyArray<RolodexHistogramFilter> {
  return useMemo<ReadonlyArray<RolodexHistogramFilter>>(
    () =>
      [
        siteId
          ? {
              type: 'site',
              field: 'id',
              op: 'in' as RolodexHistogramFilterOp,
              value: [siteId],
            }
          : undefined,
        orgId
          ? {
              type: 'organization',
              field: 'id',
              op: 'in' as RolodexHistogramFilterOp,
              value: [orgId],
            }
          : undefined,
      ].filter((item): item is NonNullable<typeof item> => !!item),
    [orgId, siteId]
  )
}
